import React, {PureComponent} from "react";
import {connect} from "react-redux";
import {Field} from "redux-form";
import RadioField from "../forms/RadioField";
import {PaymentSystems} from "../../constants/PaymentSystemConstant"
import {fetchPayments} from "../../actions/PaymentActions";

class Payment extends PureComponent {
    componentDidMount() {
        const {payments, fetchPayments} = this.props;

        if (payments === undefined || payments === null) {
            fetchPayments();
        }
    }

    renderPaymentTitle = payment => {
        const config = PaymentSystems[payment.id] || PaymentSystems.default;

        return <span><img className="credit-card" src={config.icon}/>{config.title}</span>;
    };

    render() {
        const {payments} = this.props;
        if (payments !== undefined && payments !== null) {
            return <div className="payment">
                <div className="payment__title">Payment options</div>
                <ul className="payment__list">
                    {payments.map(payment => (
                        <li key={payment.id}>
                            <Field
                                name="paymentMethod"
                                type="radio"
                                component={RadioField}
                                value={payment.pay_system_type.toString()}
                            >
                                {this.renderPaymentTitle(payment)}
                            </Field>
                        </li>
                    ))}
                </ul>
            </div>
        }
        return null;
    }
}

export default connect(
    state => ({
        payments: state.payment.payments
    }),
    dispatch => ({
        fetchPayments: () => dispatch(fetchPayments()),
    })
)(Payment);